import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

export interface CompanyStatisticsResponse {
  users: {
    total: number;
  };
  guards: {
    active: number;
    inactive: number;
    total: number;
  };
  devices: {
    total: number;
    active: number;
  };
  devicesStats: {
    total_devices: number;
    active_devices: number;
    supervisor_devices: number;
    position_devices: number;
    devices_with_notification: number;
    pending_approvals: number;
  };
  positions: {
    active: number;
    inactive: number;
    total: number;
  };
  checkins: {
    today: number;
    last7Days: number;
  };
  positionsCheckinsTable: {
    positionsWithoutCheckIn24h: number;
    lastCheckInPerPosition: Array<{
      position_id: string;
      position_name: string;
      last_check_in: string | null;
    }>;
  };
  patrols: {
    today: number;
    completedToday: number;
    inProgress: number;
  };
  patrolsStats: {
    total_routes: number;
    active_routes: number;
    total_checkpoints: number;
    patrols_today: number;
    patrols_completed_today: number;
    patrols_in_progress: number;
    compliance_rate: number;
    average_completion_time: number;
  };
  supervisors: {
    total: number;
    activeSchedules: number;
  };
  requests:{
    total:number,
    pending:number
  }
}

@Injectable({ providedIn: 'root' })
export class StatisticsService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  getStatistics(): Observable<CompanyStatisticsResponse> {
    const token = this.authService.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.get<CompanyStatisticsResponse>(`${this.baseUrl}/statistics`, { headers });
  }
}
